export const maskName = (fullName: string | null | undefined): string => {
  if (!fullName || fullName.trim() === '') {
    return '';
  }

  const name = fullName.trim();
  
  if (name.length <= 2) {
    return name[0] + '*';
  }
  
  if (name.length <= 4) {
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
  }
  
  return name.substring(0, 2) + '*'.repeat(name.length - 4) + name.substring(name.length - 2);
};